import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

import Image from '../../assets/img/blog/blog-1-1.jpg';

const SingleBlog = (props) => {
  const {
    itemClass,
    blogImage,
    publishedDate,
    publishedMonth,
    authorName,
    commentCount,
    titleClass,
    title,
    btnText,
  } = props;

  return (
    <div className={itemClass ? itemClass : 'it-blog-item'}>
      <div className="it-blog-thumb p-relative">
        <img src={blogImage ? blogImage : Image} alt="" />
        <div className="it-blog-date text-center">
          <h3 className="it-blog-date-text text-white">
            {publishedDate ? publishedDate : '10'}
          </h3>
          <span>{publishedMonth ? publishedMonth : 'March 24'}</span>
        </div>
      </div>
      <div className="it-blog-content">
        <div className="it-blog-meta">
          <span>
            <i className="flaticon-user"></i>
            {authorName ? authorName : 'Camsth Smith'}
          </span>
          <span>
            <i className="flaticon-message"></i>Comments (
            {commentCount ? commentCount : '05'})
          </span>
        </div>
        <h4 className="it-blog-title">
          <Link
            className={titleClass ? titleClass : 'hover-anim'}
            to="/blog-details"
          >
            {title ? title : 'Healthcare Tips Navigating Business Patient Care'}
          </Link>
        </h4>
        <Link className="it-btn-blog it-btn-theme" to="/blog-details">
          <Button btnText={btnText ? btnText : 'Read More'} />
        </Link>
      </div>
    </div>
  );
};

export default SingleBlog;
